'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { 
  ShieldCheck, ArrowRight, Menu, Globe, Lock, Headset, 
  Linkedin, Instagram, Youtube, Phone, Mail, Award, 
  Target, Diamond, Users, Shield, BarChart2, Flag,
  X, ChevronRight
} from 'lucide-react';

export default function SobreNosPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const wppLink = "https://wa.me/554888796761?text=Quero%20falar%20com%20um%20especialista%20sobre%20o%20sistema%20Nexus%20Safe.";
  const appLink = "https://app.nexussafe.com.br/";

  return (
    <div className="min-h-screen bg-white selection:bg-blue-200 selection:text-blue-900 font-sans text-gray-800 relative flex flex-col overflow-x-hidden">
      
      {/* ================= FIO LATERAL COLORIDO ================= */}
      <div className="hidden sm:block" style={{
        position: 'fixed',
        top: 0,
        left: '24px', 
        width: '6px',
        height: '100vh',
        background: 'linear-gradient(to bottom, #06b6d4, #3b82f6, #8b5cf6, #ec4899)', 
        zIndex: 99999,
        boxShadow: '0 0 15px rgba(59, 130, 246, 0.4)'
      }}></div>

      {/* ================= NAVBAR ================= */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 shadow-sm top-0">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative">
          
          {/* LOGO */}
          <div className="flex items-center shrink-0 h-full">
            <Link href="/" className="flex items-center">
              <img 
                src="/logo-nexus.png" 
                alt="NexusSafe" 
                style={{ height: '40px', width: 'auto' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if(fallback) fallback.style.display = 'flex';
                }}
              />
              <div style={{ display: 'none' }} className="items-center gap-2">
                <ShieldCheck size={28} className="text-gray-900" />
                <span className="text-xl font-black text-gray-900 tracking-tight">
                  NEXUS<span className="font-light">SAFE</span>
                </span>
              </div>
            </Link>
          </div>
          
          {/* LINKS DE NAVEGAÇÃO */}
          <div className="hidden md:flex items-center gap-4 lg:gap-8 font-bold text-sm text-gray-600">
            <Link href="/site/solucoes" className="hover:text-blue-600 transition-colors">Soluções</Link>
            <Link href="/site/para-quem-e" className="hover:text-blue-600 transition-colors">Para quem é</Link>
            <Link href="/site/recursos" className="hover:text-blue-600 transition-colors">Recursos</Link>
            <Link href="/site/conteudos" className="hover:text-blue-600 transition-colors">Conteúdos</Link>
            <Link href="/site/sobre-nos" className="text-blue-600 transition-colors border-b-2 border-blue-600 pb-1">Sobre nós</Link>
          </div>

          {/* BOTÕES DE AÇÃO E MENU MOBILE */}
          <div className="flex items-center gap-4 text-sm font-bold shrink-0">
            <div className="hidden md:flex items-center gap-4">
              <a href={appLink} className="text-gray-800 hover:text-blue-600 transition-colors border-r border-gray-300 pr-4">
                Entrar
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2.5 rounded-full hover:bg-blue-700 transition-all flex items-center gap-2 shadow-lg shadow-blue-600/20 whitespace-nowrap">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
            {/* Ícone Menu Mobile */}
            <button 
              className="md:hidden text-gray-800 p-2 transition-colors hover:text-blue-600"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Alternar menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* ================= MENU MOBILE (DROPDOWN) ================= */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full bg-white shadow-xl border-t border-gray-100 flex flex-col p-6 gap-4 z-40 max-h-[calc(100vh-80px)] overflow-y-auto">
            <Link href="/site/solucoes" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Soluções <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/para-quem-e" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Para quem é <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/recursos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Recursos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/conteudos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Conteúdos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/sobre-nos" onClick={() => setIsMobileMenuOpen(false)} className="text-blue-600 font-bold py-3 border-b border-gray-50 flex justify-between items-center">
              Sobre nós <ChevronRight size={16} className="text-blue-400" />
            </Link>
            
            <div className="flex flex-col gap-3 mt-4">
              <a href={appLink} className="w-full text-center text-gray-900 font-bold py-3.5 border-2 border-gray-200 rounded-full hover:bg-gray-50 transition-colors">
                Entrar no Sistema
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full bg-blue-600 text-white py-3.5 rounded-full font-bold hover:bg-blue-700 transition-all flex justify-center items-center gap-2 shadow-lg shadow-blue-600/20">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* ================= HERO SECTION ================= */}
      <section style={{ paddingTop: '180px', paddingBottom: '80px' }} className="px-6 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="space-y-6 md:space-y-8">
          <div className="text-blue-600 font-bold text-sm tracking-widest uppercase">
            Quem Somos
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-[1.1] tracking-tight">
            Conectamos <br />
            <span className="text-blue-600">pessoas, tecnologia</span> <br />
            e propósito.
          </h1>
          
          <p className="text-base md:text-lg text-gray-500 font-medium max-w-lg leading-relaxed">
            A Nexus Safe nasceu da união entre Engenharia de Segurança do Trabalho, Psicologia e Gestão de RH 
            para transformar a forma como empresas cuidam do que realmente importa: pessoas.
          </p>
          
          <div className="pt-2 md:pt-4">
            <a href={wppLink} target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-sm hover:bg-blue-700 transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-600/20 text-center w-fit">
              Fale com um especialista <ArrowRight size={16} />
            </a>
          </div>
        </div>
        
        {/* IMAGEM HERO DIREITA */}
        <div className="w-full flex justify-end relative">
           <img src="/equipe.png" alt="Equipe Nexus Safe" className="w-full max-w-[600px] h-auto object-contain drop-shadow-2xl" />
        </div>
      </section>

      {/* ================= SESSÃO HISTÓRIA E VALORES ================= */}
      <section className="py-24 bg-gray-50 relative border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-16">
          
          {/* LADO ESQUERDO: Imagem X Lateral e Box "Por que a Nexus Safe?" */}
          <div className="lg:col-span-5 relative flex flex-col items-center lg:items-start">
            <img src="/equipe_logo_lateral.png" alt="NexusSafe X Logo" className="w-full max-w-[450px] h-auto object-contain drop-shadow-xl" />
            
            {/* BOX: Por que a Nexus Safe? */}
            <div className="mt-8 bg-white p-8 rounded-3xl shadow-xl flex gap-5 items-start border-l-4 border-orange-400 w-full max-w-[450px] relative z-10 -translate-y-10 lg:-translate-y-20">
              <div className="w-14 h-14 bg-orange-50 text-orange-500 rounded-2xl flex items-center justify-center shrink-0">
                <Users size={28} />
              </div>
              <div>
                <h4 className="font-black text-xl mb-2 text-gray-900 tracking-tight">Por que a Nexus Safe?</h4>
                <p className="text-gray-500 text-sm font-medium leading-relaxed">
                  Porque somos mais que um software, somos o elo tecnológico que faltava para a sua gestão de SST e RH atingir o próximo nível.
                </p>
              </div>
            </div>
          </div>

          {/* LADO DIREITO: Timeline e Cards de Estatísticas */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            
            {/* TIMELINE */}
            <div className="relative space-y-12">
              {/* Linha Vertical da Timeline */}
              <div className="hidden sm:block absolute left-[1.65rem] top-[3rem] bottom-[3rem] w-0.5 bg-gray-200"></div>

              {/* ITEM 1: História */}
              <div className="flex gap-6 relative z-10">
                <div className="shrink-0"><div className="w-14 h-14 bg-purple-600 rounded-full flex items-center justify-center text-white shadow-lg shadow-purple-600/30"><Flag size={24}/></div></div>
                <div>
                  <h3 className="text-2xl font-black mb-3 text-gray-900">Nossa História</h3>
                  <p className="text-gray-500 font-medium leading-relaxed mb-4">
                    Nascemos da necessidade de transformar a burocracia do SST (Engenharia de Segurança do Trabalho) e RH 
                    (Psicologia e Gestão RH) em processos ágeis e digitais.
                  </p>
                  <p className="text-gray-500 font-medium leading-relaxed">
                    Essa fusão de conhecimentos permite que a Nexus Safe dê suporte para o bem-estar mental e a integridade 
                    física de forma integrada, criando a conexão perfeita para a sua gestão de RH e SST.
                  </p>
                </div>
              </div>

              {/* ITEM 2: Missão */}
              <div className="flex gap-6 relative z-10">
                <div className="shrink-0"><div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-lg shadow-blue-600/30"><Target size={24}/></div></div>
                <div>
                  <h3 className="text-2xl font-black mb-3 text-gray-900">Nossa Missão</h3>
                  <p className="text-gray-500 font-medium leading-relaxed">
                    Facilitar a conformidade normativa através de soluções inteligentes, garantindo que a segurança 
                    de trabalho seja uma prioridade acessível e eficiente.
                  </p>
                </div>
              </div>

              {/* ITEM 3: Valores */}
              <div className="flex gap-6 relative z-10">
                <div className="shrink-0"><div className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center text-white shadow-lg shadow-green-500/30"><Diamond size={24}/></div></div>
                <div>
                  <h3 className="text-2xl font-black mb-3 text-gray-900">Nossos Valores</h3>
                  <p className="text-gray-500 font-medium leading-relaxed">
                    Inovação constante, transparência nos dados e compromisso absoluto com a vida.
                  </p>
                </div>
              </div>
            </div>

            {/* CARDS DE ESTATÍSTICAS (3 COLUNAS) */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-16">
              <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center text-center hover:shadow-md transition">
                <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-4"><Shield size={24}/></div>
                <h4 className="text-2xl font-black text-blue-600 mb-1">100%</h4>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">Foco em segurança e conformidade</p>
              </div>

              <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center text-center hover:shadow-md transition">
                <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-2xl flex items-center justify-center mb-4"><Users size={24}/></div>
                <h4 className="text-2xl font-black text-purple-600 mb-1">+3.500</h4>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">empresas atendidas</p>
              </div>

              <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center text-center hover:shadow-md transition">
                <div className="w-12 h-12 bg-green-50 text-green-500 rounded-2xl flex items-center justify-center mb-4"><BarChart2 size={24}/></div>
                <h4 className="text-2xl font-black text-green-500 mb-1">+1 milhão</h4>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">de vidas impactadas</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= VAMOS CONVERSAR (IDÊNTICO À HOME) ================= */}
      <section style={{ paddingTop: '80px', paddingBottom: '160px' }} className="px-6 bg-white">
        <div 
          style={{ 
            background: 'linear-gradient(135deg, #4338CA 0%, #2563EB 100%)',
            borderRadius: '40px' 
          }} 
          className="max-w-7xl mx-auto p-10 lg:p-16 flex flex-col md:flex-row items-center justify-between relative shadow-2xl shadow-blue-600/40"
        >
          {/* TEXTOS (ESQUERDA) */}
          <div className="w-full md:w-[55%] relative z-10 text-white mb-16 md:mb-0 text-center md:text-left">
            <div className="font-bold text-sm tracking-widest uppercase mb-4 text-blue-200">Vamos conversar?</div>
            <h2 className="text-4xl lg:text-5xl font-black leading-tight tracking-tight mb-6">
              Pronto para transformar a gestão de SST na sua empresa?
            </h2>
            <p className="text-lg text-blue-100 font-medium mb-10 leading-relaxed max-w-xl mx-auto md:mx-0">
              Fale com um especialista e veja como a Nexus Safe pode simplificar sua rotina e gerar resultados.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 items-center justify-center md:justify-start">
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-white text-blue-700 px-8 py-4 rounded-full font-bold text-sm hover:bg-gray-50 transition-all flex items-center justify-center gap-2 shadow-lg">
                Falar com um especialista <ArrowRight size={16} />
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto text-white font-bold text-sm hover:text-blue-200 transition-colors flex items-center justify-center gap-2">
                Ou agende uma demonstração <ArrowRight size={16} />
              </a>
            </div>
          </div>

          {/* MOCKUP DO CELULAR (DIREITA) */}
          <div className="w-full md:w-[45%] flex justify-center md:justify-end relative z-20" style={{ minHeight: '400px' }}>
            <div style={{
              position: 'absolute',
              width: '280px',
              height: '560px',
              backgroundColor: '#ffffff',
              border: '12px solid #0f172a',
              borderRadius: '40px',
              bottom: '-100px',
              right: '5%',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
              overflow: 'hidden',
              transform: 'rotate(8deg)'
            }}>
              
              {/* Notch / Câmera */}
              <div style={{
                position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
                width: '45%', height: '24px', backgroundColor: '#0f172a',
                borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px',
                zIndex: 20
              }}></div>
              
              {/* Tela do Celular */}
              <div className="flex-1 bg-gray-50 pt-10 px-4 pb-4 overflow-hidden">
                <div className="space-y-3">
                  <div>
                    <p className="text-xs text-gray-500 font-bold">Bem-vinda,</p>
                    <p className="text-lg font-black text-gray-900">Fernanda 👋</p>
                  </div>
                  
                  <div style={{ borderRadius: '16px' }} className="bg-white border border-gray-100 p-3 shadow-sm">
                    <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Status Geral</p>
                    <div className="h-3 w-1/2 bg-blue-100 rounded mb-2"></div>
                    <div className="h-2 w-1/3 bg-gray-200 rounded"></div>
                  </div>

                  <div style={{ borderRadius: '16px' }} className="bg-white border border-gray-100 p-4 flex items-center justify-between shadow-sm">
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase">Exames em dia</p>
                      <p className="text-2xl font-black text-gray-900">98%</p>
                      <p className="text-[10px] text-green-500 font-bold">+5% vs anterior</p>
                    </div>
                    <div style={{ width: '48px', height: '48px', border: '5px solid #3b82f6', borderTopColor: '#dbeafe', borderRadius: '50%' }}></div>
                  </div>

                  <div style={{ borderRadius: '16px' }} className="bg-white border border-gray-100 p-4 shadow-sm">
                    <p className="text-[10px] font-bold text-gray-400 uppercase">Pendências</p>
                    <p className="text-xl font-black text-red-500">23</p>
                    <div className="w-full h-12 mt-2 bg-[url('https://www.transparenttextures.com/patterns/graphy.png')] opacity-30"></div>
                  </div>
                  
                  <div style={{ borderRadius: '16px' }} className="bg-white border border-gray-100 p-3 shadow-sm">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-6 h-6 bg-blue-100 rounded-full"></div>
                      <div className="h-2 w-20 bg-gray-200 rounded"></div>
                    </div>
                    <div className="h-2 w-full bg-gray-100 rounded"></div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Elemento Gráfico de fundo */}
          <div className="absolute right-0 bottom-0 w-64 h-64 border-[40px] border-white opacity-10 rounded-full translate-x-1/3 translate-y-1/3 pointer-events-none"></div>
        </div>
      </section>

      {/* ================= FOOTER (IDÊNTICO À HOME) ================= */}
      <footer style={{ backgroundColor: '#020617', paddingTop: '100px', paddingBottom: '40px' }} className="font-medium mt-auto border-t-[6px] border-blue-600">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 border-b border-gray-800 pb-16">
          
          {/* Logo Branca Fixa */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-6">
              <Link href="/" className="flex items-center">
                <img 
                  src="/logo-nexus-branca.png" 
                  alt="NexusSafe" 
                  style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const fallback = target.nextElementSibling as HTMLElement;
                    if(fallback) fallback.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none' }} className="items-center gap-2">
                  <ShieldCheck size={28} className="text-white" />
                  <span className="text-xl font-black text-white tracking-tight">NEXUSSAFE</span>
                </div>
              </Link>
            </div>
            <p style={{ color: '#9CA3AF' }} className="text-sm leading-relaxed mb-8">
              A plataforma inteligente que simplifica a gestão de Segurança e Saúde do Trabalho e conecta pessoas, dados e resultados.
            </p>
            <div className="flex gap-4">
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Linkedin size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Instagram size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Youtube size={18} /></a>
            </div>
          </div>

          {/* Links Soluções */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Soluções</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Psicossocial + Plano</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Canal de Denúncia</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Checklist</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Plano de Ação</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Entrega de EPI</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Questionários</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">CIPA</Link></li>
            </ul>
          </div>

          {/* Links Para quem é */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Para quem é</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Indústrias</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Construtoras</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Comércio</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Serviços</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Saúde</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Educação</Link></li>
            </ul>
          </div>

          {/* Links Recursos & Sobre */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Recursos</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-8">
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Materiais</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Webinars</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Cases</Link></li>
            </ul>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Sobre Nós</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Institucional</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Parceiros</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>

          {/* Contato Direto */}
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Fale Conosco</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-3"><Phone size={14} className="shrink-0"/> (48) 9.8879-6761</li>
              <li className="flex items-center gap-3"><Mail size={14} className="shrink-0"/> comercial@nexussafe.com.br</li>
            </ul>
            <a href={wppLink} target="_blank" rel="noopener noreferrer" className="inline-flex bg-blue-600 text-white px-5 py-2.5 rounded-full font-bold text-xs hover:bg-blue-700 transition-all items-center gap-2">
              Fale com um especialista <ArrowRight size={14} />
            </a>
          </div>

        </div>

        <div style={{ color: '#9CA3AF' }} className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p className="text-center md:text-left">© 2026 NexusSafe - Criado por Leandro Rodrigo de Oliveira - Todos os direitos reservados</p>
          <div className="flex items-center gap-6">
            <a href="https://nexussafe.com.br/site/privacidade" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Política de Privacidade</a>
            <a href="https://nexussafe.com.br/site/termos" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Termos de Uso</a>
          </div>
        </div>
      </footer>

    </div>
  );
}